module.exports = __webpack_public_path__ + "static/media/segmento-alimentacao.53a3e83d.gif";